/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';
import { OnboardingAnswer } from '../../API';

export interface EndUserOnboardingState {
  endUserSpaceOnboardingAnswers: Array<OnboardingAnswer>;
  endUserSpaceOnboardingChosenSharedProgrammeID?: string | null;
}

const initialState: EndUserOnboardingState = {
  endUserSpaceOnboardingAnswers: [],
  endUserSpaceOnboardingChosenSharedProgrammeID: null,
};

export const endUserOnboardingSlice = createSlice({
  name: 'endUserOnboarding',
  initialState,
  reducers: {
    answersAvailable: (
      state,
      action: PayloadAction<EndUserOnboardingState>,
    ) => {
      Object.assign(state, action.payload);
    },
    answersReset: (state) => {
      state.endUserSpaceOnboardingAnswers = [];
      state.endUserSpaceOnboardingChosenSharedProgrammeID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.endUserSpaceOnboardingAnswers = [];
      state.endUserSpaceOnboardingChosenSharedProgrammeID = null;
    });
  },
});

export const { answersAvailable, answersReset } =
  endUserOnboardingSlice.actions;

export default endUserOnboardingSlice.reducer;
